/**
 * 创建人：D
 * 创建时间：2019-07-12
 * 描述：待办的全局事项
 * 更新记录:
 */

import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { SwHttpClientService } from '../sw-http-client.service';
import { environment } from 'src/environments/environment';
import { SwJwtService } from '../sw-jwt.service';
import { SystemIdService } from './system-id.service';


/**
 * 待办信息的获取数据
 *
 */
@Injectable()
export class ProcessToDosService {
  /**
   * 订阅待办发布数据
   * @ignore
   */
  processUpdated: Subject<any> = new Subject<any>();
  /**
   * 保存待办数据
   * @ignore
   */
  processList: any; //保存待办数据

  /**
   * 订阅通知消息
   * @ignore
   */
  noticeUpdated: Subject<any> = new Subject<any>();

  /**
   * 保存订阅消失
   * @ignore
   */
  noticeList: any = [];

  /**
   * 订阅已办发布数据
   * @ignore
   */
  completionUpdated: Subject<any> = new Subject<any>();
  /**
  * 保存已办数据
  * @ignore
  */
  completionList: any; //保存已办数据

  /**
  * 订阅已发发布数据
  * @ignore
  */
  publishedUpdated: Subject<any> = new Subject<any>();
  /**
  * 保存已发数据
  * @ignore
  */
  publishedList: any; //保存已发数据

  /**
   * 订阅odc公告通知发布数据    合并代码需保留
   * @ignore
   */
  odcNoticeUpdated: Subject<any> = new Subject<any>();
  /**
  * 保存odc公告通知  合并代码需保留
  * @ignore
  */
  odcNoticeList: any; //odc公告通知

  /**
   * 订阅待发发布数据
   * @ignore
   */
  toPublishUpdated: Subject<any> = new Subject<any>();
  /**
  * 保存待发数据
  * @ignore
  */
  toPublishList: any; //保存已发数据

  /**
   * @ignore
   * @param http 请求
   * @param jwt  浏览器缓存
   */
  constructor(
    private http: SwHttpClientService,  //封装的http请求服务
    private jwt: SwJwtService, //本地缓存服务
    private systemId: SystemIdService,
  ) { }


  /**
   * 刷新工作台待办流程，已办流程和已发流程 (因为前期工作台只有待办，现在增加了已发和已办，所以提取了公共方法)
   */
  oninitProcessToDos() {
    this.oninitToDoToDos(); //待办
    this.oninitCompletionToDos(); //已办
    this.oninitPublishedToDos(); //已发
  }

  /**
   * 获取前五条待办事项 
   */
  oninitToDoToDos() {
    this.http.Post(environment.activitiWebAPI + "swActivitiTaskRecord/getPersonalTaskList", { pageNum: 1, pageSize: 5 }).subscribe(
      result => {
        if (result["code"] == 200) {
          if (result["data"]) {
            //保存待办数据
            this.processList = result["data"];
            //发布待办
            this.processUpdated.next(result["data"])
          }
        }
      }
    )
  }

  /**
 * 获取前五条已办事项 
 */
  oninitCompletionToDos() {
    this.http.Post(environment.activitiWebAPI + "swActivitiTaskRecord/getPersonalAlreadyDoneList", { pageNum: 1, pageSize: 5 }).subscribe(
      result => {
        if (result["code"] == 200) {
          if (result["data"]) {
            //保存已办数据
            this.completionList = result["data"];
            //发布已办
            this.completionUpdated.next(result["data"])
          }
        }
      }
    )
  }
  /**
  * 获取前五条已发事项
  */
  oninitPublishedToDos() {
    this.http.Post(environment.activitiWebAPI + "swActivitiTaskRecord/getPublishedList", { pageNum: 1, pageSize: 5 }).subscribe(
      result => {
        if (result["code"] == 200) {
          if (result["data"]) {
            //保存已发数据
            this.publishedList = result["data"];
            //发布已发
            this.publishedUpdated.next(result["data"])

          }
        }
      }
    )
  }
  /**
   * 获取前五条odc公告通知   合并代码需保留
   */
  oninitOdcNotice(type) {
    let url = environment[type] + "odcAnnouncementNotice/queryPageList"
    let params = {
      entity: { isPublish: 1 },
      param: { pageNum: 1, pageSize: 5 }
    }
    this.http.Post(url, params).subscribe(
      result => {
        if (result["code"] == 200) {
          if (result["data"]) {
            //保存已办数据
            this.odcNoticeList = result["data"];
            //发布已办
            this.odcNoticeUpdated.next(result["data"])
          }
        }
      }
    )
  }
  /**
   * 获取前五条通知信息
   */
  oninitNotice() {
    //获取用户属性
    let userModel = JSON.parse(this.jwt.getToken("User"));
    //绑定查询对象
    let params = {
      "param": { pageNum: 1, pageSize: 5 },
      "entity": { "isRead": false, "receiver": userModel["userId"] }
    }
    //获取请求id
    const url = environment.seekerWebAPI + 'message/queryPageList';
    this.http.Post(url, params).subscribe(data => {
      //请求成功
      if (data["code"] == 200) {

        //判断获取的数据和原数据是否一致
        let result = false;
        if (this.noticeList && typeof this.noticeList === 'object' && this.noticeList.records && this.noticeList.records.length > 0) {
          const ids1 = this.noticeList.records.map(item => item.messageId).sort();//原数据的messageId
          const ids2 = data["data"].records.map(item => item.messageId).sort();//获取到的数据的messageId
          result = JSON.stringify(ids1) === JSON.stringify(ids2);//判断两个messageId是否一致
        }

        //数据不一致更新订阅信息
        if (!result) {
          this.noticeList = data["data"];
          // 只获取前五条, 要显示消息的总数,需要将分页数据也带过去
          this.noticeUpdated.next(this.noticeList)
        }
      }
    });
  }

  /**
   * 
   * 获取前五条待发数据
   */

  oninitToPublish() {
    let selectData = {}
    selectData['systemId'] = this.systemId.getSystemId();
    let param = { entity: selectData, param: { pageNum: 1, pageSize: 5 } };
    this.http.Post(environment.activitiWebAPI + "todoProcess/queryPageList", param).subscribe(
      result => {
        if (result["code"] == 200) {
          if (result["data"]) {
            //保存待发数据
            this.toPublishList = result["data"];
            //发布待发
            this.toPublishUpdated.next(result["data"])

          }
        }
      }
    )
  }



  /**
 * 启动审批流程
 * @param param
 * @returns {Observable<any>}
 */
  startActiviti(param) {
    const url = environment.activitiWebAPI + 'activitiRunTime/startPIWithIdAndVar';
    return this.http.Post(url, param);
  }

  /**
   * 审核组件进行审核操作的消息
   * @ignore
   */
  audit: Subject<any> = new Subject<any>();
  sendAuditMessage(message: any) {
    //发布
    this.audit.next(message)
    this.oninitNotice();
  }
  getAuditMessage() {
    return this.audit.asObservable()
  }

  /**
   * 待发列表更新操作的消息,
   * 1.点击发起流程--填写业务数据--点击保存待发--刷新待发列表 
   * 2.点击待发流程--选中数据点进去--点击保存并提交--刷新待发列表
   * 3.刷新待发列表方法:  调用此服务中的 sendtoPublishedMsg 方法,并传入随机字符串, 如: this.process.sendtoPublishedMsg("我是随机字符串")
   * @ignore
   */
  toPublishedUpdated: Subject<any> = new Subject<any>();
  sendtoPublishedMsg(message: any) {
    //外部调用该方法的时候,将纯如的值进行发布,那么订阅此值的观察者就睡受到消息
    this.toPublishedUpdated.next(message)
  }
  gettoPublishedMsg() {
    return this.toPublishedUpdated.asObservable()
  }
}
